// extracted by mini-css-extract-plugin
export var container = "loadingring-module--container--2LyLo";
export var spin = "loadingring-module--spin--11pP9";